<script lang="ts" setup></script>

<template>
    <component
        :is="$attrs.for ? 'label' : 'div'"
        class="font-condensed text-sm font-medium uppercase tracking-wide text-green-100"
    >
        <slot />
    </component>
</template>

<style scoped></style>
